import { render } from "./Navbar.vue?vue&type=template&id=36772142&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "@/css/components/c-navbar.css?vue&type=style&index=0&id=36772142&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36772142"]])

export default __exports__